// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bottom-bar {
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 10px 210px 10px 1fr 10px 61px 10px;
}
#bottom-bar #bottom-bar-total {
  grid-row: 1;
  grid-column: 6;
  color: white;
  background: #222222;
  height: 25px;
  align-self: center;
  font-size: 12pt;
}
#bottom-bar #bottom-bar-total #clip-range {
  width: 100%;
}
#bottom-bar .control-button .control-button-image {
  display: unset;
}
#bottom-bar .control-button .control-button-hover-image {
  display: none;
}
#bottom-bar .control-button:hover {
  cursor: pointer;
}
#bottom-bar .control-button:hover .control-button-image {
  display: none;
}
#bottom-bar .control-button:hover .control-button-hover-image {
  display: unset;
}
#bottom-bar .control-button:active {
  transform-origin: 50% 50%;
  transform: scale(0.96);
}
#bottom-bar #media-player {
  grid-row: 1;
  grid-column: 2;
  display: grid;
  align-self: center;
  justify-self: center;
  grid-template-rows: 100%;
  grid-template-columns: 23px 23px 23px 23px 23px 23px 23px;
}
#bottom-bar #media-player #start-key {
  grid-row: 1;
  grid-column: 1;
}
#bottom-bar #media-player #prev-frame {
  grid-row: 1;
  grid-column: 2;
}
#bottom-bar #media-player #first-key {
  grid-row: 1;
  grid-column: 3;
}
#bottom-bar #media-player #rev-key {
  grid-row: 1;
  grid-column: 4;
}
#bottom-bar #media-player #fwd-key {
  grid-row: 1;
  grid-column: 5;
}
#bottom-bar #media-player #next-key {
  grid-row: 1;
  grid-column: 6;
}
#bottom-bar #media-player #next-frame {
  grid-row: 1;
  grid-column: 7;
}
#bottom-bar #media-player #end-key {
  grid-row: 1;
  grid-column: 8;
}
#bottom-bar #range-selector {
  grid-row: 1;
  grid-column: 4;
  background: #222222;
  width: 100%;
  height: calc(100% - 20px);
  margin: 10px 0;
  position: relative;
}
#bottom-bar #range-selector #range-scrollbar {
  position: absolute;
  left: 2px;
  top: 2px;
  right: 2px;
  bottom: 2px;
  background: #666666;
  display: grid;
  grid-template-rows: 100%;
  grid-template-columns: 20px auto 1fr auto 20px;
  color: #222222;
  font-family: "acumin-pro-condensed";
  font-size: 14px;
  min-width: 70px;
}
#bottom-bar #range-selector #range-scrollbar #left-handle {
  grid-row: 1;
  grid-column: 1;
}
#bottom-bar #range-selector #range-scrollbar #right-handle {
  grid-row: 1;
  grid-column: 5;
}
#bottom-bar #range-selector #range-scrollbar #from-key {
  grid-row: 1;
  grid-column: 2;
  align-self: center;
  justify-self: center;
  user-select: none;
  pointer-events: none;
}
#bottom-bar #range-selector #range-scrollbar #to-key {
  grid-row: 1;
  grid-column: 4;
  align-self: center;
  justify-self: center;
  user-select: none;
  pointer-events: none;
}
#bottom-bar #range-selector #range-scrollbar .handle {
  width: 20px;
  align-self: center;
  justify-self: center;
  cursor: pointer;
  user-select: none;
}
#bottom-bar #range-selector #range-scrollbar .handle img {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./../../../dev/inspector/dist/components/actionTabs/tabs/propertyGrids/animations/curveEditor/scss/bottomBar.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,wBAAA;EACA,yDAAA;AACJ;AACI;EACI,WAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AACR;AACQ;EACI,WAAA;AACZ;AAIQ;EACI,cAAA;AAFZ;AAKQ;EACI,aAAA;AAHZ;AAMQ;EACI,eAAA;AAJZ;AAMY;EACI,aAAA;AAJhB;AAOY;EACI,cAAA;AALhB;AASQ;EACI,yBAAA;EACA,sBAAA;AAPZ;AAWI;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,yDAAA;AATR;AAWQ;EACI,WAAA;EACA,cAAA;AATZ;AAYQ;EACI,WAAA;EACA,cAAA;AAVZ;AAaQ;EACI,WAAA;EACA,cAAA;AAXZ;AAcQ;EACI,WAAA;EACA,cAAA;AAZZ;AAeQ;EACI,WAAA;EACA,cAAA;AAbZ;AAgBQ;EACI,WAAA;EACA,cAAA;AAdZ;AAiBQ;EACI,WAAA;EACA,cAAA;AAfZ;AAkBQ;EACI,WAAA;EACA,cAAA;AAhBZ;AAoBI;EACI,WAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;AAlBR;AAoBQ;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,cAAA;EACA,mCAAA;EACA,eAAA;EACA,eAAA;AAlBZ;AAoBY;EACI,WAAA;EACA,cAAA;AAlBhB;AAqBY;EACI,WAAA;EACA,cAAA;AAnBhB;AAsBY;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AApBhB;AAuBY;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;AArBhB;AAwBY;EACI,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;AAtBhB;AAwBgB;EACI,oBAAA;AAtBpB","sourcesContent":["#bottom-bar {\r\n    display: grid;\r\n    grid-template-rows: 100%;\r\n    grid-template-columns: 10px 210px 10px 1fr 10px 61px 10px;\r\n\r\n    #bottom-bar-total {\r\n        grid-row: 1;\r\n        grid-column: 6;\r\n        color: white;\r\n        background: #222222;\r\n        height: 25px;\r\n        align-self: center;\r\n        font-size: 12pt;\r\n\r\n        #clip-range {\r\n            width: 100%;\r\n        }\r\n    }\r\n\r\n    .control-button {\r\n        .control-button-image {\r\n            display: unset;\r\n        }\r\n\r\n        .control-button-hover-image {\r\n            display: none;\r\n        }\r\n\r\n        &:hover {\r\n            cursor: pointer;\r\n\r\n            .control-button-image {\r\n                display: none;\r\n            }\r\n\r\n            .control-button-hover-image {\r\n                display: unset;\r\n            }\r\n        }\r\n\r\n        &:active {\r\n            transform-origin: 50% 50%;\r\n            transform: scale(0.96);\r\n        }\r\n    }\r\n\r\n    #media-player {\r\n        grid-row: 1;\r\n        grid-column: 2;\r\n        display: grid;\r\n        align-self: center;\r\n        justify-self: center;\r\n        grid-template-rows: 100%;\r\n        grid-template-columns: 23px 23px 23px 23px 23px 23px 23px;\r\n\r\n        #start-key {\r\n            grid-row: 1;\r\n            grid-column: 1;\r\n        }\r\n\r\n        #prev-frame {\r\n            grid-row: 1;\r\n            grid-column: 2;\r\n        }\r\n\r\n        #first-key {\r\n            grid-row: 1;\r\n            grid-column: 3;\r\n        }\r\n\r\n        #rev-key {\r\n            grid-row: 1;\r\n            grid-column: 4;\r\n        }\r\n\r\n        #fwd-key {\r\n            grid-row: 1;\r\n            grid-column: 5;\r\n        }\r\n\r\n        #next-key {\r\n            grid-row: 1;\r\n            grid-column: 6;\r\n        }\r\n\r\n        #next-frame {\r\n            grid-row: 1;\r\n            grid-column: 7;\r\n        }\r\n\r\n        #end-key {\r\n            grid-row: 1;\r\n            grid-column: 8;\r\n        }\r\n    }\r\n\r\n    #range-selector {\r\n        grid-row: 1;\r\n        grid-column: 4;\r\n        background: #222222;\r\n        width: 100%;\r\n        height: calc(100% - 20px);\r\n        margin: 10px 0;\r\n        position: relative;\r\n\r\n        #range-scrollbar {\r\n            position: absolute;\r\n            left: 2px;\r\n            top: 2px;\r\n            right: 2px;\r\n            bottom: 2px;\r\n            background: #666666;\r\n            display: grid;\r\n            grid-template-rows: 100%;\r\n            grid-template-columns: 20px auto 1fr auto 20px;\r\n            color: #222222;\r\n            font-family: \"acumin-pro-condensed\";\r\n            font-size: 14px;\r\n            min-width: 70px;\r\n\r\n            #left-handle {\r\n                grid-row: 1;\r\n                grid-column: 1;\r\n            }\r\n\r\n            #right-handle {\r\n                grid-row: 1;\r\n                grid-column: 5;\r\n            }\r\n\r\n            #from-key {\r\n                grid-row: 1;\r\n                grid-column: 2;\r\n                align-self: center;\r\n                justify-self: center;\r\n                user-select: none;\r\n                pointer-events: none;\r\n            }\r\n\r\n            #to-key {\r\n                grid-row: 1;\r\n                grid-column: 4;\r\n                align-self: center;\r\n                justify-self: center;\r\n                user-select: none;\r\n                pointer-events: none;\r\n            }\r\n\r\n            .handle {\r\n                width: 20px;\r\n                align-self: center;\r\n                justify-self: center;\r\n                cursor: pointer;\r\n                user-select: none;\r\n\r\n                img {\r\n                    pointer-events: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
